import React, { Fragment, useState } from 'react';
import PropTypes from 'prop-types';
import css from './ProductInfo.module.css';
import SizeDropdown from '../SIzeDropdown/SizeDropdown';
import { FormattedMessage } from 'react-intl';
import { priceData } from '../../../../components/ListingCard/ListingCard';
import { NamedLink, FormattedAttributes } from '../../../../components';
import { createSlug } from '../../../../util/urlHelpers';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
function ProductInfo({ item, removeItem, editAmount, intl, currentUser }) {
  const [quantityValue, setQuantityValue] = useState(item.quantity);
  const { formattedPrice: price, priceTitle: title } = priceData(item.attributes.price, intl);

  const id = item.id.uuid;
  const hasPurchaseQuantityCap =
    !!item?.attributes?.publicData?.purchaseQuantityCap &&
    parseInt(item?.attributes?.publicData?.purchaseQuantityCap) !== 0;
  const purchaseQuantityCap = hasPurchaseQuantityCap
    ? parseInt(item.attributes.publicData.purchaseQuantityCap)
    : 1000000;
  const purchasedProducts =
    currentUser?.attributes?.profile?.privateData?.purchasedProducts &&
    Array.isArray(currentUser?.attributes?.profile?.privateData?.purchasedProducts)
      ? currentUser?.attributes?.profile?.privateData?.purchasedProducts
      : [];
  const isProductAlreadyPurchased = purchasedProducts.some(product => product.id === id);
  const purchasedQuantity = isProductAlreadyPurchased
    ? parseInt(purchasedProducts.find(product => product.id === id)?.quantity)
    : 0;

  const { title: ItemTitle = '' } = item.attributes;
  const slug = createSlug(ItemTitle);

  const outOfStock = item.stock.attributes.quantity == 0;
  const handleClick = () => {
    removeItem(item.id.uuid, currentUser);
  };

  const handleChange = e => {
    setQuantityValue(e.target.value);
    editAmount(item.id.uuid, e.target.value, currentUser);
  };
  return (
    <div className={css.root}>
      <div className={css.itemDetails}>
      <NamedLink className={css.itemListingLink} name="ListingPage" params={{ id, slug }}>
        <div className={css.title}>{item.attributes.title}</div>
      </NamedLink>
 
             <p className={css.price}>{price}</p>
      <div className={css.variants}>
 
        <FormattedAttributes
          variantType={item.attributes.publicData.variantType}
          allAttributes={item.attributes.publicData.attributes}
        />
      </div>

</div>
      <div className={css.quantityContainer}>
        <SizeDropdown
          selectedValue={parseInt(quantityValue)}
          stock={item.stock.attributes.quantity}
          purchaseQuantityCap={purchaseQuantityCap}
          purchasedQuantity={purchasedQuantity}
          onChange={handleChange}
        />
        <button className={css.quantityButton} onClick={handleClick}>
          {outOfStock ? <div className={css.outOfStockInfo}>Out of stock</div> : null}
          <FontAwesomeIcon icon="trash-alt" />
        </button>
      </div>
    </div>
  );
}

ProductInfo.propTypes = {
  item: PropTypes.object,
};

export default ProductInfo;
